export default __webpack_public_path__ + "static/media/csv-svgrepo-com.eb9c58ee.svg";